import { ChangeDetectionStrategy,  Component, Inject, input } from '@angular/core';

import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-ktostamm-kunde-field-ok-data-view',
  imports: [],
  templateUrl: './ktostamm-kunde.list-view.html',
  styleUrls: ['./ktostamm-kunde.list-view.css'],
})
export class KtostammKundeListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();

  constructor() {}
}
